import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { GITES } from "@/data";
import { GroupOffer } from "@/components/GroupOffer";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.1, ease: "easeOut" } }),
};

export default function Maisons() {
  return (
    <div data-testid="page-maisons" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <span className="text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">Les gîtes</span>
          <h1 className="font-serif text-5xl lg:text-6xl font-light mt-5 text-forest">Deux gîtes indépendants</h1>
          <p className="text-charcoal/70 mt-6 text-lg">Chacun son atmosphère, son point de vue, son rythme. Choisissez le vôtre.</p>
        </div>

        <div className="space-y-20">
          {GITES.map((g, i) => (
            <motion.div key={g.id} data-testid={`maisons-card-${g.id}`} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }} variants={fadeUp}
              className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <Link to={g.path} className="overflow-hidden rounded-2xl group">
                <img src={g.cover} alt={g.name} className="w-full h-[420px] object-cover group-hover:scale-105 transition-transform duration-700" />
              </Link>
              <div>
                <h2 className="font-serif text-4xl text-forest">{g.name}</h2>
                <a href={g.booking} target="_blank" rel="noopener noreferrer" data-testid={`maisons-reviews-${g.id}`} className="inline-block mt-2 text-sm text-forest underline underline-offset-4 hover:text-forest-dark">
                  Lire les avis sur Booking →
                </a>
                <p className="text-charcoal/70 mt-4 leading-relaxed">{g.tagline}</p>
                <p className="text-charcoal/60 mt-3 leading-relaxed">{g.description}</p>
                <div data-testid={`maisons-compare-${g.id}`} className="mt-5 rounded-xl bg-stone/50 border border-sand px-4 py-3 text-sm text-charcoal/80 leading-relaxed">
                  <p>{g.sqm} m² · Jusqu'à {g.guests} voyageurs · {g.bedrooms} chambres</p>
                  <p className="text-charcoal/60">{g.highlights}</p>
                </div>
                <Link to={g.path}>
                  <button data-testid={`maisons-voir-${g.id}`} className="inline-flex items-center gap-2 mt-6 rounded-full bg-forest hover:bg-forest-dark text-cream px-7 h-11 text-sm transition-colors">
                    Découvrir {g.name} <ArrowRight className="w-4 h-4" />
                  </button>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        <GroupOffer />
      </div>
    </div>
  );
}
